import { AppRoute } from '../../../core/routing/AppRoute';
import { HomePage } from './pages/home/home.page';
import { AuthGuard } from '../../common/rest-api/services/auth-guard.service';

// A feature route should be used in the App routing module in most cases and primarily provide
// a base url and module loading functionality.
// The feature route should employ a load children callback that loads the appropriate module
const Feature = new AppRoute({
  segment: 'home',
  title: 'Home',
  // A component can also be included to be the content, or a separate route with a blank segment
  // can be defined like below to provide a dedicated route instance
  // component: GarmentListingPage,
  loadChildren: () => import('./home.module').then(m => m.homeModule),
  canActive: [AuthGuard]
});

// "Sub-routes" should be the contentful endpoints for the feature. To provide content at the base
// level of the feature url, simply leave segment blank.
// Provide the parent parameter to be able to derive the fullPath of a route that includes the base
const homePage = new AppRoute({
  segment: '',
  title: 'Home Page',
  component: HomePage,
  parent: Feature,
  canActive: [AuthGuard]
});

// const Customer = new AppRoute({
//   segment: 'customer/:id',
//   title: 'Cancel Order Customer',
//   component: CustomerCancelOrderPage,
//   parent: Feature,
//   canActive: [AuthGuard]
// });

// const Department = new AppRoute({
//   segment: 'department/:id/:cid',
//   title: 'Cancel Order Department',
//   component: DepartmentCancelOrderPage,
//   parent: Feature,
//   canActive: [AuthGuard]
// });

// const Employee = new AppRoute({
//   segment: 'employee/:id/:cid/:did',
//   title: 'Cancel Order Employee',
//   component: EmployeeCancelOrderPage,
//   parent: Feature,
//   canActive: [AuthGuard]
// });


export const homeRoute = {
  Feature: Feature,
  HomePage:homePage
}